
















































































import {
  defineComponent,
  ref,
  onMounted,
  PropType,
} from "@vue/composition-api";
import {
  getMapDemandPointData,
  IReqDemandPoint,
  IResDemandPoint,
  getMapServicePointData,
  IReqServicePoint,
  IResServicePoint,
  getJobType,
  IResJobType,
  getMachineryType,
  IResMachineryType,
} from "@/api/njfw";
import { useAppStore } from "@/store/app";
import { PagingParameters } from "@/api/util";

export type IColumns = {
  prop: string;
  label: string;
  subProp: string;
  unit: string;
  join: string;
};

export default defineComponent({
  props: {
    title: {
      type: String,
      default: "需求大厅",
    },
    type: {
      type: String,
      default: "demand",
    },
    columns: {
      type: Array as PropType<IColumns[]>,
      default: () => [
        {
          prop: "address",
          label: "作业地点",
          subProp: "",
          unit: "",
          join: "",
        },
        {
          prop: "jobTypeName",
          label: "所需农机",
          subProp: "machineTypeName",
          unit: "",
          join: "-",
        },
        {
          prop: "landArea",
          label: "作业面积",
          subProp: "areaUnitName",
          unit: "",
          join: "",
        },
        {
          prop: "jobTimeStart",
          label: "作业时间",
          subProp: "jobTimeStart",
          unit: "",
          join: "/",
        },
      ],
    },
  },
  emits: ["handleRowDbClick"],
  setup(props, { emit }) {
    const appStore = useAppStore();

    const filter = ref<(IReqDemandPoint | IReqServicePoint) & PagingParameters>(
      {
        jobType: "",
        machineType: "",
        locId: appStore.locId,
        page: 1,
        size: 10,
        totalCount: 0,
      }
    );
    const tables = ref<HTMLElement | any>();
    const tableLists = ref<IResDemandPoint[] | IResServicePoint[]>([]);
    const jobTypeList = ref<IResJobType[]>([]);
    const MachineryTypeList = ref<IResMachineryType[]>([]);
    const isTableFold = ref<boolean>(false);

    // 获取需求列表
    const getMapDataList = async () => {
      const api =
        props.type === "demand"
          ? getMapDemandPointData
          : getMapServicePointData;
      const [err, data] = await api(filter.value);
      if (!err && data !== undefined && data.data !== null) {
        tableLists.value = data.data;
        filter.value.totalCount = data.totalCount;
      }
    };
    // 分页
    const handleCurrentChange = (page: number) => {
      filter.value.page = page;

      tables.value.$el.scrollTop = 0;

      getMapDataList();
    };
    // 列表项双击
    const handleRowDbClick = (row: any) => {
      emit("handleRowDbClick", row);
    };
    // 更新作业类型
    const changeJobType = (id: number) => {
      getMachineryTypeList(id);
      filter.value.machineType = "";

      if (!id) {
        getMapDataList();
      }
    };
    // 获取作业类型
    const getJobTypeList = async () => {
      const [err, data] = await getJobType();
      if (!err && data !== undefined) {
        jobTypeList.value = data;
      }
    };
    // 获取农机类型
    const getMachineryTypeList = async (jobTypeId: number) => {
      const [err, data] = await getMachineryType(jobTypeId);
      if (!err && data !== undefined) {
        MachineryTypeList.value = data;
      }
    };

    onMounted(() => {
      getMapDataList();
      getJobTypeList();
    });

    return {
      filter,
      tables,
      tableLists,
      jobTypeList,
      MachineryTypeList,
      isTableFold,
      getMapDataList,
      handleRowDbClick,
      handleCurrentChange,
      changeJobType,
      getJobTypeList,
    };
  },
});
